import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, makeStyles } from '@material-ui/core';
import { getLoanVehicleHistory } from '../../../Core/Service/loan-vehicle-service';
import formatters from '../../../Core/Grid/inputFormatter';
import DialogComp from '../../../Core/Modal/dialogModal';
import LoanVehicleBooking from '../loanVehicleBooking';

const useStyles = makeStyles((theme) => ({
    table: {
        '& .MuiTableCell-root': {
            padding: '6px 12px',
            fontSize: '0.875rem'
        }
    },
    stripedRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9'
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#ffffff'
        }
    },
    clickable: {
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: 'bold',
        color: theme.palette.primary.main
    }
}));

const LoanVehicleHistory = ({ id }) => {
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [state, setState] = useState({
        showLoanUsageModal: false,
        tCardID: null,
        tCardsBranchID: null
    });

    useEffect(() => {
        if (id) {
            let fetchHistory = async () => {
                setLoading(true);
                const res = await getLoanVehicleHistory(id);

                if (res?.success) {
                    const data = res?.data?.detail?.table || [];
                    const formatted = data.map((item, index) => ({ id: index + 1, ...item }));
                    setRows(formatted);
                }

                setLoading(false);
            };
            fetchHistory();
        }
    }, [id]);

    const handleRedirect = (row) => {
        if (row.headerRecordID && row.workflowID) {
            history.push(`/Job/${row.headerRecordID}/${row.workflowID}`);
        } else {
            console.error('Missing headerRecordID or workflowID');
        }
    };

    const getDaysOnLoan = (dateOut, dateIn) => {
        if (!dateOut) return '-';
        const start = new Date(dateOut);
        const end = dateIn ? new Date(dateIn) : new Date();
        const diff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
        return diff >= 0 ? diff : '-';
    };

    const handleLoanVehicle = (row) => {
        if (!row.tCardsID) {
            console.error('Vehicle ID is missing');
            return;
        }
        setState((st) => ({
            ...st,
            showLoanUsageModal: true,
            tCardID: row.tCardsID,
            tCardsBranchID: row.branchID
        }));
    };

    const closeLoanVehicle = (row) => {
        setState((st) => ({
            ...st,
            showLoanUsageModal: false,
            tCardID: null
        }));
    };

    return (
        <div className="report-screen-container">
            {loading ? (
                <div style={{ textAlign: 'center', margin: '20px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading Vehicle History...</Typography>
                </div>
            ) : rows.length === 0 ? (
                <Typography style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}>No Vehicle History</Typography>
            ) : (
                <TableContainer component={Paper} style={{ maxHeight: '400px' }}>
                    <Table className={classes.table} stickyHeader>
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                                <TableCell>Handed Over</TableCell>
                                <TableCell>Returned</TableCell>
                                <TableCell>Days On Loan</TableCell>
                                <TableCell>WIP No.</TableCell>
                                <TableCell>Reg No.</TableCell>
                                <TableCell>Customer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.id} className={classes.stripedRow}>
                                    <TableCell className={classes.clickable} onClick={() => handleLoanVehicle(row)}>
                                        {row.dateOut ? formatters.DateTimeFormatter(row.dateOut) : '-'}
                                    </TableCell>
                                    <TableCell>{row.dateIn ? formatters.DateTimeFormatter(row.dateIn) : '-'}</TableCell>
                                    <TableCell>{getDaysOnLoan(row.dateOut, row.dateIn)}</TableCell>
                                    <TableCell>
                                        <span className={classes.clickable} onClick={() => handleRedirect(row)}>
                                            {row.wipNumber}
                                        </span>
                                    </TableCell>
                                    <TableCell>{row.regNumber}</TableCell>
                                    <TableCell>{row.customer}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {state.showLoanUsageModal ? (
                <DialogComp title="Loan Vehicle Details" onClose={closeLoanVehicle} maxWidth="xl" overflow="auto" fullWidth>
                    <LoanVehicleBooking tCardID={state.tCardID} onClose={closeLoanVehicle} BranchID={state.tCardsBranchID} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default LoanVehicleHistory;
